export enum LTPartType {
  AngleSection = "AngleSection",
  Corner = "Corner",
  CornerBrace = "CornerBrace",
  Dish = "Dish",
  Foot = "Foot",
  Handle = "Handle",
  Hinge = "Hinge",
  /** Klavierband segment; derived from Hinge, uses PianoHingeType option. */
  PianoHinge = "PianoHinge",
  Lock = "Lock",
  Pad = "Pad",
  Panel = "Panel",
  Profile = "Profile",
  RackRail = "RackRail",
  Roller = "Roller",
  TrayPanel = "TrayPanel",
  TrolleyHandle = "TrolleyHandle",
  Volume = "Volume",
  Measurements = "Measurements",
  SlideRail = "SlideRail",
}
